import {find} from '../helpers';

const element = find('[data-dialog]');

if (element) {
    import('./index');
}
